<template>
  <div
    class="social-simulation"
    :class="socialClasses"
  >
    <InstagramSimulation></InstagramSimulation>
    <LinkedInSimulation></LinkedInSimulation>
  </div>
</template>

<script>
import { scrollPositionMixin } from '@/mixins'
import InstagramSimulation from './InstagramSimulation'
import LinkedInSimulation from './LinkedInSimulation'

export default {
  name: 'SocialSimulation',
  data () {
    return {
      done: false
    }
  },
  mixins: [scrollPositionMixin],
  components: {
    InstagramSimulation,
    LinkedInSimulation
  },
  watch: {
    reached () {
      if (!this.done) {
        this.done = true
      }
    }
  },
  computed: {
    socialClasses () {
      return {
        'is-appear': this.done
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.social-simulation {
  width: 100%;
  margin: 0 auto;
  padding-left: 10px;
  padding-right: 10px;
  transition: all 2500ms cubic-bezier(.19,1,.22,1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
  opacity: 0;
  transform: translateY(25px);
  max-width: 340px;

  @media (min-width: 768px) {
    max-width: 520px;
  }
}
.is-appear {
  opacity: 1;
  transform: translateY(0px);
}
</style>



// WEBPACK FOOTER //
// src/components/social/SocialSimulation.vue